// Port of api/fuel/app/classes/filter/package/games/play/prepare/previous.php
import DB from 'offline/db'
import Util from 'offline/util'
import F from 'offline/filter/constants'

function sumPlayCount(whereSql, params) {
	var rows = DB.query('SELECT SUM(play_count) AS total FROM play WHERE ' + whereSql, params)
	return rows.length && rows[0].total !== null ? (parseInt(rows[0].total, 10) || 0) : 0
}

export default {
	require: function(config, filter) { return !filter.play || !filter.play.group },
	run: function(local, global) {
		local.previous = {
			user: 0,
			userContext: 0,
			group: 0,
			groupContext: 0
		}

		if (!local.result) return local

		var gameId = local.result.game_id
		var userId = local.result.user_id
		var playDate = local.result.play_date
		var playId = local.result.play_id
		var contextFrom = global.filter && global.filter.played && global.filter.played.range
			? global.filter.played.range.from
			: false

		local.previous.user = sumPlayCount('play_date < ? AND game_id = ? AND user_id = ?', [playDate, gameId, userId])
		local.previous.user += sumPlayCount('play_date = ? AND play_id < ? AND game_id = ? AND user_id = ?', [playDate, playId, gameId, userId])

		if (contextFrom) {
			local.previous.userContext = sumPlayCount('play_date >= ? AND play_date < ? AND game_id = ? AND user_id = ?', [contextFrom, playDate, gameId, userId])
			local.previous.userContext += sumPlayCount('play_date = ? AND play_id < ? AND game_id = ? AND user_id = ?', [playDate, playId, gameId, userId])
		}

		if (global.ownerType !== F.OWNER_USER) {
			local.previous.group = sumPlayCount('play_date < ? AND game_id = ? AND user_id IN(' + Util.in(global.userIndex) + ')', [playDate, gameId])
			local.previous.group += sumPlayCount('play_date = ? AND play_id < ? AND game_id = ? AND user_id IN(' + Util.in(global.userIndex) + ')', [playDate, playId, gameId])

			if (contextFrom) {
				local.previous.groupContext = sumPlayCount('play_date >= ? AND play_date < ? AND game_id = ? AND user_id IN(' + Util.in(global.userIndex) + ')', [contextFrom, playDate, gameId])
				local.previous.groupContext += sumPlayCount('play_date = ? AND play_id < ? AND game_id = ? AND user_id IN(' + Util.in(global.userIndex) + ')', [playDate, playId, gameId])
			}
		}

		return local
	}
}
